// Restricted (c) Siemens Healthineers AG, 2025, All rights reserved.

import { Injectable } from '@angular/core';
import { DnaSyngoviaNodeEType } from '../interfaces/dna-syngovia-node';
import { DnaSyngoviaImgIconModel } from '../model/dna-syngovia-img-icon-model';

@Injectable({ providedIn: 'root' })
export class DnaSyngoviaIconService {
  private readonly unknownIcon = new DnaSyngoviaImgIconModel();

  private readonly deviceTypeImgIconDictionarty = {
    at: new DnaSyngoviaImgIconModel({
      type: 'at',
      alt: 'Image icon for Advanced Therapy device',
    }),
    syngovia: new DnaSyngoviaImgIconModel({
      type: 'syngovia',
      alt: 'Image icon for Digital and Automation device',
    }),
    us: new DnaSyngoviaImgIconModel({
      type: 'us',
      alt: 'Image icon for Ultrasound device',
    }),
    ct: new DnaSyngoviaImgIconModel({
      type: 'ct',
      alt: 'Image icon for CT device',
    }),
    xp_rf: new DnaSyngoviaImgIconModel({
      type: 'xp_rf',
      alt: 'Image icon for XP Radiograph device',
    }),
    xp_su: new DnaSyngoviaImgIconModel({
      type: 'xp_su',
      alt: 'Image icon for XP Surgery device',
    }),
    xp_ur: new DnaSyngoviaImgIconModel({
      type: 'xp_ur',
      alt: 'Image icon for XP Urine device',
    }),
    xp_wh: new DnaSyngoviaImgIconModel({
      type: 'xp_wh',
      alt: 'Image icon for XP Mamograph device',
    }),
    mr: new DnaSyngoviaImgIconModel({
      type: 'mr',
      alt: 'Image icon for MR device',
    }),
    mi: new DnaSyngoviaImgIconModel({
      type: 'mi',
      alt: 'Image icon for MI device',
    }),
    printer: new DnaSyngoviaImgIconModel({
      type: 'printer',
      alt: 'Image icon for Printer device',
    }),
    cd_burner: new DnaSyngoviaImgIconModel({
      type: 'cd_burner',
      alt: 'Image icon for CD Burner device',
    }),
    client: new DnaSyngoviaImgIconModel({
      type: 'workstation',
      alt: 'Image icon for Workstation device',
    }),
    server: new DnaSyngoviaImgIconModel({
      type: 'server',
      alt: 'Image icon for Server device',
    }),
    ris: new DnaSyngoviaImgIconModel({
      type: 'ris',
      alt: 'Image icon for Ris device',
    }),
    pacs: new DnaSyngoviaImgIconModel({
      type: 'pacs',
      alt: 'Image icon for Image Icon Pacs device',
    }),
    customized: new DnaSyngoviaImgIconModel({
      type: 'unknown',
      alt: 'Image icon for Customized device',
    }),
    workstation: new DnaSyngoviaImgIconModel({
      type: 'unknown',
      alt: 'Image icon for Workstation device',
    }),
    dicom_proxy: new DnaSyngoviaImgIconModel({
      type: 'dicom_proxy',
      alt: 'Image icon for DICOM Proxy device',
    }),
    othermodalities: new DnaSyngoviaImgIconModel({
      type: 'unknown',
      alt: 'Image icon for Other Modalities device',
    }),
    teamplay: new DnaSyngoviaImgIconModel({
      type: 'teamplay',
      alt: 'Image icon for teamplay device',
    }),
    default: this.unknownIcon,
  };

  public getImgIcon(nodeType: DnaSyngoviaNodeEType): DnaSyngoviaImgIconModel {
    let imgIcon = this.deviceTypeImgIconDictionarty.default;

    if (this.deviceTypeImgIconDictionarty[nodeType]) {
      imgIcon = this.deviceTypeImgIconDictionarty[nodeType];
    }

    return imgIcon;
  }
}
